module.exports = __webpack_public_path__ + "img/k-6_img.9bef1e62.png";